var video_viewer_default = {
  "video_player": "_36V06",
  "videoOverlay": "Ha1MM",
  "video_container": "P9nHk"
};
export {
  video_viewer_default as default
};
//# sourceMappingURL=video-viewer-scss.js.map
